class GridColumnSwitch extends HTMLElement {
  constructor() {
    super();

    if (!this.hasAttribute('grid')) {
      return;
    }

    this.gridId = this.getAttribute('grid');
    this.buttons = this.querySelectorAll('[data-column]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        const column = parseInt(e.currentTarget.dataset.column);

        this.setColumn(column);
        this.updateGrid();
      });
    });

    this.updateGrid();
  }

  updateGrid() {
    const column = this.getColumn();

    if (!column) {
      return;
    }

    const grid = this.getGrid();

    if (!grid) {
      return;
    }

    grid.style.setProperty('--grid-desktop-columns', column);

    this.buttons.forEach((button) => button.classList.remove('active'));
    this.querySelector('[data-column="' + column + '"]').classList.add('active');
  }

  getGrid() {
    return document.getElementById(this.getAttribute('grid'));
  }

  setColumn(column) {
    setCookie('grid_column_' + this.gridId, column);

    // Update param in URL if exits.
    const url = new URL(window.location.href);

    if (url.searchParams.get('column')) {
      url.searchParams.set('column', column);
      window.history.replaceState({}, '', url);
    }
  }

  getColumn() {
    // Prefer getting from URL.
    const url = new URL(window.location.href);
    var column = url.searchParams.get('column');

    if (column) {
      return column;
    }

    // Get from cookie.
    const cached = getCookie('grid_column_' + this.gridId);

    if (cached) {
      return cached;
    }

    // Get column from grid dataset.
    const grid = this.getGrid();

    if (grid) {
      column = parseInt(grid.dataset.column);

      if (!column) {
        const style = getComputedStyle(grid);
        column = parseInt(style.getPropertyValue('--grid-desktop-columns'));
      }

      return column;
    }

    // Last resort. Get from buttons.
    this.buttons.forEach((button) => {
      if (button.classList.contains('active')) {
        column = parseInt(button.dataset.column);
        return;
      }
    });

    if (column) {
      return column;
    }

    return parseInt(this.buttons[0].dataset.column);
  }
}

customElements.define('grid-column-switch', GridColumnSwitch);
